import { createContext, useContext } from 'react';

// What every ProteoRisk page shares: the theme, the browser credential, the
// active pipeline contract and this browser's analyses.
export const ProteoRiskContext = createContext(null);

export function useProteoRisk() {
  const value = useContext(ProteoRiskContext);
  if (!value) throw new Error('ProteoRisk pages must render inside the ProteoRisk shell');
  return value;
}
